const PlacardBedroomIcon = ({ width = 20 }) => (
  <svg width={width} height={width} viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M20 17.5H18.75M11.25 17.5H10H11.25Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M15 2.5V27.5M15 2.5H25.5C25.6989 2.5 25.8897 2.57902 26.0303 2.71967C26.171 2.86032 26.25 3.05109 26.25 3.25V26.75C26.25 26.9489 26.171 27.1397 26.0303 27.2803C25.8897 27.421 25.6989 27.5 25.5 27.5H15V2.5ZM15 2.5H4.5C4.30109 2.5 4.11032 2.57902 3.96967 2.71967C3.82902 2.86032 3.75 3.05109 3.75 3.25V26.75C3.75 26.9489 3.82902 27.1397 3.96967 27.2803C4.11032 27.421 4.30109 27.5 4.5 27.5H15V2.5Z" stroke="currentColor" strokeWidth="1.5" />
  </svg>
);

export default PlacardBedroomIcon;
